import { faFileCirclePlus, faFileXml, faFolderOpen, faUserMagnifyingGlass, faUsers, faUsersMedical, faBellRing, faUsersGear } from "@fortawesome/pro-duotone-svg-icons";
import { Permission } from '../enums/permission.enum';

export interface HomeBox {
  name: string;
  routerLink: string;
  icon: any;
  requiredPermission: Permission;
}

export const HOME_BOXES: HomeBox[] = [
  {
    name: 'Gestor Campañas',
    routerLink: '/declarations',
    icon: faFolderOpen,
    requiredPermission: Permission.ManageCampaigns
  },
  {
    name: 'Maestro Clientes',
    routerLink: '/clients',
    icon: faUsersMedical,
    requiredPermission: Permission.ManageClients
  },
  {
    name: 'Gestión Usuarios',
    routerLink: '/users',
    icon: faUsersGear,
    requiredPermission: Permission.ManageUsers
  },
  {
    name: 'Solicitudes de alta',
    routerLink: '/client-requests',
    icon: faBellRing,
    requiredPermission: Permission.ManageRequests
  }
  // {
  //   name: 'Visualización Clientes',
  //   routerLink: '/clients-master',
  //   icon: faUserMagnifyingGlass
  // },
  // {
  //   name: 'Modificar archivo XML',
  //   routerLink: '/xml-transform',
  //   icon: faFileXml
  // }
  // {
  //   name: 'Añadir modelo',
  //   routerLink: '/new-model',
  //   icon: faFileCirclePlus
  // }
];